module.exports = __webpack_public_path__ + "media/images/loading-spinner-purple-3fe4eba2.svg";